import * as React from 'react'
import { cn } from '../lib/utils'

export interface PageShellProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Header component (typically navigation) */
  header?: React.ReactNode
  /** Footer component */
  footer?: React.ReactNode
}

/**
 * Page shell component providing consistent layout structure.
 * Wraps the main content with optional header and footer.
 */
const PageShell = React.forwardRef<HTMLDivElement, PageShellProps>(
  ({ className, header, footer, children, ...props }, ref) => {
    return (
      <div ref={ref} className={cn('flex min-h-screen flex-col', className)} {...props}>
        {header}
        <main className="flex-1">{children}</main>
        {footer}
      </div>
    )
  }
)
PageShell.displayName = 'PageShell'

export { PageShell }
